export default "__VITE_ASSET__CoFIOQ$t__"